import { Link } from 'gatsby'
import React from 'react'

export default ({ header, slug, title, date, excerpt }) => (
  <Link
    to={slug}>
    <div className='message m-b-lg' style={{ border: '1px solid #0D050E', height: 'fit-content' }}>
      {
        header &&
        <div className='message-header'>
          <p>{header}</p>
        </div>
      }
      <article className='media'>
        <div className='media-content p-md'>
          <p className='title is-5'>{title}</p>
          <p className='subtitle is-6'>{!(slug.includes('initial')) && date}</p>
          <div className='content'>
            {excerpt}
          </div>
        </div>
      </article>
    </div>
  </Link>
)
